import {
  notificationProvider,
  RefineSnackbarProvider,
  CssBaseline,
  GlobalStyles,
  ThemeProvider,
  LightTheme,
  ReadyPage,
  ErrorComponent,
} from "@pankod/refine-mui";
import { Layout } from "@pankod/refine-antd";

import routerProvider from "@pankod/refine-react-router-v6";
import { MuiInferencer } from "@pankod/refine-inferencer/mui";
import { UserList } from "pages/users";
import { OtpList } from "pages/otps";
import { BalanceList } from "pages/bybit-balances";
import { TradeList } from "pages/bybit-trades";
import authProvider from "authProvider";
import dataProvider from "dataProvider";
import { Refine } from "@pankod/refine-core";
import { AuthPage } from "components/pages/auth";
import { BotList, BotCreate, BotEdit } from "pages/bots";
import { SubscriptionList } from "pages/subscriptions";
import { REST_PUBLIC_URI } from "environment";
import { CreditList } from "pages/credits/list";
import { CreditCreate } from "pages/credits";
import { TierList, TierCreate, TierEdit } from "pages/tiers";
import {
  TierPriceList,
  TierPriceCreate,
  TierPriceEdit,
} from "pages/tier-prices";
import {
  BotAffiliateCreate,
  BotAffiliateUpdate,
  BotAffiliateList,
} from "pages/bot-affiliates";
import {
  BotExchangeCreate,
  BotExchangeUpdate,
  BotExchangeList,
} from "pages/bot-exchanges";
import {
  TierSubscriptionList,
  TierSubscriptionCreate,
  TierSubscriptionEdit,
} from "pages/tiers-subscriptions";
import { OkxBalanceList } from "pages/okx-balances/list";
import { OkxTradeList } from "pages/okx-trades/list";
import { BingxBalanceList } from "pages/bingx-balances/list";
import { BingxTradeList } from "pages/bingx-trades/list";
import { CredentialAccountList } from "pages/credential-accounts/list";
import {
  NotificationCreate,
  NotificationEdit,
  NotificationList,
} from "pages/notifications";
import { BannerCreate, BannerEdit, BannerList } from "pages/banners";
import { TagUserRewardList } from "pages/tag-user-rewards";
import {
  TagConditionEdit,
  TagConditionList,
  TagConditionCreate,
} from "pages/tag-conditions";
import {
  TagRewardCreate,
  TagRewardEdit,
  TagRewardList,
} from "pages/tag-rewards";
import {
  TagActionCreate,
  TagActionEdit,
  TagActionList,
} from "pages/tag-actions";
import { UserWalletList } from "pages/user-wallet/list";
import { TXHistoryList } from "pages/tx-history/list";
import { FinjamWalletEdit, FinjamWalletList } from "pages/finjam-wallet";
import { UserStatList } from "pages/user-stats";
import { SubscriptionStatList } from "pages/subscription-stats";
import { UniverseTradeList } from "pages/universe-trades/list";
import { UniverseBalanceList } from "pages/universe-balances/list";

function App() {
  return (
    <ThemeProvider theme={LightTheme}>
      <CssBaseline />
      <GlobalStyles styles={{ html: { WebkitFontSmoothing: "auto" } }} />
      <RefineSnackbarProvider
        style={{ position: "absolute", top: "85vh", left: "-98vw" }}
      >
        <Refine
          dataProvider={dataProvider(`${REST_PUBLIC_URI}/api/admin/v1`)}
          authProvider={authProvider}
          routerProvider={{
            ...routerProvider,
            routes: [{ path: "/login", element: <AuthPage type="login" /> }],
          }}
          notificationProvider={notificationProvider}
          Layout={Layout}
          Title={({ collapsed }) => (
            <div
              style={{
                width: "100%",
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                marginTop: "24px",
              }}
            >
              <img
                src={require("./components/logo/finjam-logo.png")}
                alt="Finjam Logo"
                style={{ width: "80%" }}
              />
            </div>
          )}
          ReadyPage={ReadyPage}
          catchAll={<ErrorComponent />}
          LoginPage={AuthPage}
          resources={[
            {
              name: "User",
            },
            // {
            //   name: "users",
            //   parentName: "User",
            //   list: UserList,
            //   show: MuiInferencer,
            // },
            {
              name: "user-stats",
              parentName: "User",
              list: UserStatList,
              show: MuiInferencer,
              options: { label: "Users" },
            },
            {
              name: "otps",
              parentName: "User",
              list: OtpList,
              show: MuiInferencer,
            },
            {
              name: "accounts",
              parentName: "User",
              list: CredentialAccountList,
              show: MuiInferencer,
              options: { label: "Credential accounts" },
            },
            {
              name: "Bot",
            },
            {
              name: "bots",
              parentName: "Bot",
              list: BotList,
              show: MuiInferencer,
              create: BotCreate,
              edit: BotEdit,
              canDelete: true,
            },
            {
              name: "bots/exchange",
              parentName: "Bot",
              create: BotExchangeCreate,
              edit: BotExchangeUpdate,
              list: BotExchangeList,
              show: MuiInferencer,
              canDelete: true,
              options: { label: "Exchanges" },
            },
            {
              name: "bots/affiliate",
              parentName: "Bot",
              create: BotAffiliateCreate,
              edit: BotAffiliateUpdate,
              list: BotAffiliateList,
              show: MuiInferencer,
              canDelete: true,
              options: { label: "Affiliates" },
            },
            {
              name: "Subscription",
            },
            // {
            //   name: "bot/subscriptions",
            //   parentName: "Subscription",
            //   list: SubscriptionList,
            //   show: MuiInferencer,
            //   options: { label: "Subscriptions" },
            // },
            {
              name: "bot/subscription-stats",
              parentName: "Subscription",
              list: SubscriptionStatList,
              show: MuiInferencer,
              options: { label: "Subscriptions" },
            },
            {
              name: "trades/okx",
              parentName: "Subscription",
              list: OkxTradeList,
              show: MuiInferencer,
              options: { label: "Okx Trades" },
            },
            {
              name: "balances/okx",
              parentName: "Subscription",
              list: OkxBalanceList,
              show: MuiInferencer,
              options: { label: "Okx Balances" },
            },
            {
              name: "trades/universe",
              parentName: "Subscription",
              list: UniverseTradeList,
              show: MuiInferencer,
              options: { label: "Universe Trades" },
            },
            {
              name: "balances/universe",
              parentName: "Subscription",
              list: UniverseBalanceList,
              show: MuiInferencer,
              options: { label: "Universe Balances" },
            },
            {
              name: "trades/bingx",
              parentName: "Subscription",
              list: BingxTradeList,
              show: MuiInferencer,
              options: { label: "Bingx Trades" },
            },
            {
              name: "balances/bingx",
              parentName: "Subscription",
              list: BingxBalanceList,
              show: MuiInferencer,
              options: { label: "Bingx Balances" },
            },
            {
              name: "trades/bybit",
              parentName: "Subscription",
              list: TradeList,
              show: MuiInferencer,
              options: { label: "Bybit Trades" },
            },
            {
              name: "balances/bybit",
              parentName: "Subscription",
              list: BalanceList,
              show: MuiInferencer,
              options: { label: "Bybit Balances" },
            },
            {
              name: "Tiers",
            },
            {
              name: "tiers",
              parentName: "Tiers",
              list: TierList,
              show: MuiInferencer,
              create: TierCreate,
              edit: TierEdit,
              canDelete: true,
            },
            {
              name: "tier-prices",
              parentName: "Tiers",
              list: TierPriceList,
              show: MuiInferencer,
              create: TierPriceCreate,
              edit: TierPriceEdit,
              canDelete: true,
            },
            {
              name: "tier-subscriptions",
              parentName: "Tiers",
              list: TierSubscriptionList,
              show: MuiInferencer,
              create: TierSubscriptionCreate,
              edit: TierSubscriptionEdit,
              canDelete: true,
            },
            {
              name: "credits",
              list: CreditList,
              show: MuiInferencer,
              create: CreditCreate,
            },
            {
              name: "notifications",
              create: NotificationCreate,
              edit: NotificationEdit,
              list: NotificationList,
              show: MuiInferencer,
            },
            {
              name: "banners",
              create: BannerCreate,
              edit: BannerEdit,
              list: BannerList,
              show: MuiInferencer,
              canDelete: true,
            },
            {
              name: "Tag",
            },
            {
              name: "tags/condition",
              parentName: "Tag",
              create: TagConditionCreate,
              edit: TagConditionEdit,
              list: TagConditionList,
              show: MuiInferencer,
              canDelete: true,
              options: { label: "Tag conditions" },
            },
            {
              name: "tags/reward",
              parentName: "Tag",
              create: TagRewardCreate,
              edit: TagRewardEdit,
              list: TagRewardList,
              show: MuiInferencer,
              canDelete: true,
              options: { label: "Tag rewards" },
            },
            {
              name: "tags/user/reward",
              parentName: "Tag",
              list: TagUserRewardList,
              show: MuiInferencer,
              canDelete: true,
              options: { label: "Tag user rewards" },
            },
            {
              name: "tags/action",
              parentName: "Tag",
              create: TagActionCreate,
              edit: TagActionEdit,
              list: TagActionList,
              show: MuiInferencer,
              canDelete: true,
              options: { label: "Tag actions" },
            },
            {
              name: "PaymentAndFinance",
            },
            {
              name: "get-finjam-wallets",
              parentName: "PaymentAndFinance",
              list: FinjamWalletList,
              show: MuiInferencer,
              options: { label: "Finjam wallet" },
              // edit: FinjamWalletEdit,
              // canDelete: true,
            },
            {
              name: "user-wallets",
              parentName: "PaymentAndFinance",
              list: UserWalletList,
              show: MuiInferencer,
              options: { label: "User wallet" },
            },
            {
              name: "tx-history-shamans",
              parentName: "PaymentAndFinance",
              list: TXHistoryList,
              show: MuiInferencer,
              options: { label: "TX history" },
            },
          ]}
        />
      </RefineSnackbarProvider>
    </ThemeProvider>
  );
}

export default App;
